/* jshint esnext: true */
import { $document, APP_NAME, $body } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'Stat';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    TRIGGER: `trigger.Stat`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        // Declaration of properties

    }

    init() {
        for (var i = 0; i < this.$el.attr('data-statValue').length; i++) {
            let $span;

            if(this.$el.attr('data-statValue')[i] != ' ') {
                $span = $('<span class="c-product-content_stat_value_item js-stat-item"><span class="c-product-content_stat_value_item_inner js-stat-item-inner"><span>0</span><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span><span>6</span><span>7</span><span>8</span><span>9</span></span></span>');
            }else {
                $span = $('<span class="c-product-content_stat_value_item js-stat-item -separator"><span class="c-product-content_stat_value_item_inner js-stat-item-inner"><span>0</span><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span><span>6</span><span>7</span><span>8</span><span>9</span></span></span>');
            }
            this.$el.append($span);
        }

        $document.on(EVENT.TRIGGER, (event) => {
            if (event.way === 'enter') {
                for (var i = 0; i < this.$el.attr('data-statValue').length; i++) {
                    TweenMax.to($('.js-stat-item').eq(i).find('.js-stat-item-inner'),1,{
                        y: - ((parseInt(this.$el.attr('data-statValue')[i]) + 1)*10) + '%',
                        delay: 0.3 + (i * 0.1)
                    });
                }
            } else if (event.way === 'leave') {
                // for (var i = 0; i < this.$el.attr('data-statValue').length; i++) {
                //     TweenMax.to($('.js-stat-item').eq(i).find('.js-stat-item-inner'),0.6,{
                //         y: '0%'
                //     });
                // }
            }
        })
    }

    destroy() {
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }

}
